<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii"></a>
<h1 class="toc-title">Contents</h1>
<h2 class="tocf"><a href="#/xhtml/Listofplates"><em class="italic">List of Plates</em></a></h2>
<h2 class="tocf"><a href="#/xhtml/Evolution"><em class="italic">The Evolution of the KGB 1917–2017</em></a></h2>
<h2 class="tocf"><a href="#/xhtml/Abbreviations"><em class="italic">Abbreviations and Acronyms</em></a></h2>
<h2 class="tocf"><a href="#/xhtml/Transliteration"><em class="italic">Transliteration of Russian Names</em></a></h2>
<h2 class="tocf"><a href="#/xhtml/Preface"><em class="italic">Preface</em></a></h2>
<h2 class="tocf"><a href="#/xhtml/Foreword"><em class="italic">Foreword and Acknowledgements</em></a></h2>
<h2 class="tocf"><a href="#/xhtml/Introduction"><em class="italic">Introduction: From the Okhrana to the National Guard</em></a></h2>
<h2 class="tocc"><a href="#/xhtml/Chapter01"><span class="tsp">Chapter 1</span> Origins of the Cheka</a></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter02" title="Link target outside of Sample"><span class="tsp">Chapter 2</span> Lenin, Trotsky, and His Majesty’s Secret Service</span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter03" title="Link target outside of Sample"><span class="tsp">Chapter 3</span> The Russian Civil War, Foreign Intervention, the Fate of the Romanovs, and British-American Intelligence</span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter04" title="Link target outside of Sample"><span class="tsp">Chapter 4</span> Comintern: Secret Soldiers of the Revolution</span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter05" title="Link target outside of Sample"><span class="tsp">Chapter 5</span> The Looting of Russia</span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter06" title="Link target outside of Sample"><span class="tsp">Chapter 6</span> Disinformburo and Early Deception Operations</span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter07" title="Link target outside of Sample"><span class="tsp">Chapter 7</span> First ‘Illegals’ and ‘Rezidents’</span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter08" title="Link target outside of Sample"><span class="tsp">Chapter 8</span> Trade, Diplomacy and Famine</span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter09" title="Link target outside of Sample"><span class="tsp">Chapter 9</span> The Raids</span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter10" title="Link target outside of Sample"><span class="tsp">Chapter 10</span> The Russians are Coming</span></h2>
<h2 class="tocc"><span href="#/xhtml/Chapter11" title="Link target outside of Sample"><span class="tsp">Chapter 11</span> Soviet House, British Spy Mania and SIS Activities in Russia: The ARCOS Tangle</span></h2>
<h2 class="tocbt"><span href="#/xhtml/Appendix" title="Link target outside of Sample"><em class="italic">Appendix: Lenin and the Cheka</em></span></h2>
<h2 class="tocb"><span href="#/xhtml/Notes" title="Link target outside of Sample"><em class="italic">Notes</em></span></h2>
<h2 class="tocb"><span href="#/xhtml/Bibliography" title="Link target outside of Sample"><em class="italic">Recommended Reading</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?663b988b